/*
 * Created by alex@hackerbay.com on 10.1.2019
 * Copyright Singularity Technologies GmbH (c) 2019. All rights reserved
 */

const PackageTrackingStatus = {
    DELIVERED: "Delivered_001"
};

export {PackageTrackingStatus}